import { Popup, popupBoilerplate } from './Popup';
import PopupStickers from 'src/game/stickers/popups/PopupStickers';
import PopupCheatsAB from './PopupCheatsAB';
import PopupError from './PopupError';
import PopupNetworkError from './PopupNetworkError';
import PopupReplicationError from './PopupReplicationError';
import PopupSessionDesyncError from './PopupSessionDesyncError';
import PopupVersionError from './PopupVersionError';
import PopupInfo from './PopupInfo';
import PopupFaq from './PopupFaq';
import PopupModalWhite from './PopupModalWhite';
import PopupConversationScript from '../conversation/PopupConversationScript';
import PopupSelectionalScript from '../conversation/PopupSelectionalScript';
import PopupDescriptiveScript from '../conversation/PopupDescriptiveScript';
import PopupPetNameInput from '../conversation/PopupPetNameInput';
import PopupWantToAddFriend from '../conversation/PopupWantToAddFriend';
import PopupSelectCareItem from '../../popups/PopupSelectCareItem';
import PopupConfirmCareItem from '../../popups/PopupConfirmCareItem';
import PopupTermsPolicyDetails from '../termsPolicy/details/PopupTermsPolicyDetails';
import PopupConfirmation from './PopupConfirmation';
import PopupSpeechBubble from '../conversation/PopupSpeechBubble';
import PopupTutorialStep from '../../popups/PopupTutorialStep';
import PopupTutorialReward from '../../popups/PopupTutorialReward';
import PopupEncyclopediaTutorial from '../../encyclopedia/PopupEncyclopediaTutorial';
import PopupFeatureDisabled from '../../popups/PopupFeatureDisabled';
import PopupAcceptToS from '../../popups/PopupAcceptToS';
import PopupInviteReward from '../../popups/PopupInviteReward';
import PopupInviteFriends from '../../popups/PopupInviteFriends';
import PopupConfirmInvite from '../../popups/PopupConfirmInvite';
import PopupConfirmInviteMulti from '../../popups/PopupConfirmInviteMulti';
import PopupCoinsShop from '../../shop/PopupCoinsShop';
import PopupCoinsExchanged from '../../shop/PopupCoinsExchanged';
import PopupEnergyShop from '../../shop/PopupEnergyShop';
import PopupEnergyExchanged from '../../shop/PopupEnergyExchanged';
import PopupNewPurchaseComplete from 'src/game/shop/PopupNewPurchaseComplete';
import PopupPurchaseCanceled from 'src/game/shop/PopupPurchaseCanceled';
import PopupPurchaseFailed, {
  PopupPurchaseFatal,
} from 'src/game/shop/PopupPurchaseFailed';
import PopupAdminReimburse from '../../popups/PopupAdminReimburse';
import PopupAdminRename from 'src/game/popups/PopupAdminRename';
import PopupEditProfile from 'src/game/popups/PopupEditProfile';
import PopupAvatarSelection from 'src/game/popups/PopupAvatarSelection';
import PopupProfile from 'src/game/popups/PopupProfile';
import PopupSettings from '../../settings/popup/PopupSettings';
import PopupGiftsList from '../../gifts/PopupGiftsList';
import PopupGiftsConfirmation from 'src/game/gifts/PopupGiftsConfirmation';
import PopupGiftsConfirmationMulti from 'src/game/gifts/PopupGiftsConfirmationMulti';
import PopupLevelUPReward from 'src/game/level/popups/PopupLevelUPReward';
import PopupEncyclopedia from 'src/game/encyclopedia/PopupEncyclopedia';
import PopupEncyclopediaDetails from 'src/game/encyclopedia/PopupEncyclopediaDetails';
import PopupVisitFriend from '../../visit/popups/PopupVisitFriend';
import PopupConfirmVisitFriend from '../../visit/popups/PopupConfirmVisitFriend';
import PopupVisitReward from 'src/game/visit/popups/PopupVisitReward';
import PopupLoginCrossplay from '../../native/popups/PopupLoginCrossplay';
import PopupNativeLineGuestLogin from '../../native/popups/PopupNativeLineGuestLogin';
import PopupInstallNativeReward from '../../native/popups/PopupInstallNativeReward';
import PopupDuoResponse from 'src/game/duo/popup/PopupDuoResponse';
import PopupDuoInvitations from 'src/game/duo/popup/PopupDuoInvitations';
import PopupDuoResponseSuccess from 'src/game/duo/popup/PoupDuoResponseSuccess';
import PopupDuoReminderConfirmation from 'src/game/duo/popup/PopupDuoReminderConfirmation';
import PopupDuoReminderSuccess from 'src/game/duo/popup/PoupDuoReminderSuccess';
import PopupDuoReward from 'src/game/duo/popup/PopupDuoReward';
import PopupGrowthRecord from 'src/game/family/popups/PopupGrowthRecord';
import PopupFamilyTree from 'src/game/family/popups/PopupFamilyTree';
import PopupDecorationPurchaseConfirmation from 'src/game/decoration/PopupDecorationPurchaseConfirmation';
import PopupSelectDecorationRoom from 'src/game/decoration/PopupSelectDecorationRoom';
import PopupConfirmDaycare from '../../daycare/PopupConfirmDaycare';
import PopupExitDaycare from '../../daycare/PopupExitDaycare';
import PopupInviteChallengeComplete from 'src/game/popups/PopupInviteChallengeComplete';
import PopupInviteChallenge from 'src/game/popups/PopupInviteChallenge';
import PopupToSUpdated from 'src/game/popups/PopupToSUpdated';
import PopupCatalogItemSell from 'src/game/catalog/PopupCatalogItemSell';
import PopupCatalogList from 'src/game/catalog/PopupCatalogList';
import PopupShadowBox from './PopupShadowBox';
import PopupConfirmGrowthCapsule from '../../popups/PopupConfirmGrowthCapsule';
import PopupNotification from './PopupNotification';
import PopupPNPermissionReminder from 'src/game/native/popups/PopupPNPermissionReminder';
import PopupPNPermission from '../../native/popups/PopupPNPermission';
import PopupStarsPinch from 'src/game/minigame/match2-timestep/components/PopupStarsPinch';
import PopupConfirmMatch2Booster from 'src/game/minigame/match2-timestep/components/PopupConfirmMatch2Booster';
import PopupConfirmationWhite from './PopupConfirmationWhite';
import PopupMatch2Pregame from 'src/game/minigame/match2-timestep/components/PopupMatch2Pregame';
import PopupConfirmMatch2Powerup from 'src/game/minigame/match2-timestep/components/PopupConfirmMatch2Powerup';
import PopupMatch2LevelComplete from 'src/game/minigame/match2-timestep/components/PopupMatch2LevelComplete';
import PopupMatch2LevelFailed from 'src/game/minigame/match2-timestep/components/PopupMatch2LevelFailed';
import PopupMatch2Pinch from 'src/game/minigame/match2-timestep/components/PopupMatch2Pinch';
import PopupMatch2DailyBonus from 'src/game/minigame/match2-timestep/components/PopupMatch2DailyBonus';
import PopupDailyBonusTosNudge from 'src/game/minigame/match2-timestep/dailybonus/PopupDailyBonusTosNudge';
import PopupTosPuzzlePinchNudge from 'src/game/tosPuzzlePinch/PopupTosPuzzlePinchNudge';
import PopupMatch2GrantRewards from 'src/game/minigame/match2-timestep/components/PopupMatch2GrantRewards';
import PopupMatch2FrenzyIntro from 'src/game/minigame/match2-timestep/components/PopupMatch2FrenzyIntro';
import PopupMatch2PlayOnApp from 'src/game/minigame/match2-timestep/components/PopupMatch2PlayOnApp';
import PopupMatch2Tournament from 'src/game/minigame/match2-timestep/tournament/PopupMatch2Tournament';
import PopupMatch2TournamentInfo from 'src/game/minigame/match2-timestep/tournament/PopupMatch2TournamentInfo';
import PopupMatch2DailyChallenge from 'src/game/minigame/match2-timestep/dailychallenge/PopupMatch2DailyChallenge';
import PopupRedoEvolution from 'src/game/popups/PopupRedoEvolution';
import PopupRedoEvolutionChoice from 'src/game/popups/PopupRedoEvolutionChoice';
import PopupOpenWebPay from 'src/game/iap/popups/PopupOpenWebPay';
import PopupMatch2RacesIntro from 'src/game/minigame/match2-timestep/races/popups/PopupMatch2RacesIntro';
import PopupMatch2TimedRacesLeaderboard from 'src/game/minigame/match2-timestep/races/popups/PopupMatch2TimedRacesLeaderboard';
import PopupMatch2TargetRacesLeaderboard from 'src/game/minigame/match2-timestep/races/popups/PopupMatch2TargetRacesLeaderboard';
import PopupMatch2ShopBundles from 'src/game/minigame/match2-timestep/shopbundles/PopupMatch2ShopBundles';
import PopupMatch2Chest from 'src/game/minigame/match2-timestep/components/PopupMatch2Chest';
import PopupMatch2Quit from 'src/game/minigame/match2-timestep/components/PopupMatch2Quit';
import PopupMatch2TournamentStreak from 'src/game/minigame/match2-timestep/tournament/PopupMatch2TournamenStreak';
import PopupMatch2BundleSale from 'src/game/minigame/match2-timestep/bundlesale/PopupMatch2BundleSale';
import PopupMatch2PinchTournamentStreak from 'src/game/minigame/match2-timestep/components/PopupMatch2PinchTournamentStreak';
import PopupLeaguesInfoPuzzleCoins from 'src/game/minigame/match2-timestep/leagues/popups/PopupLeaguesInfoPuzzleCoins';
import PopupMatch2FreeContinue from 'src/game/minigame/match2-timestep/components/PopupMatch2FreeContinue';
import PopupMatch2MagicLamps from 'src/game/minigame/match2-timestep/magiclamps/PopupMatch2MagicLamps';
import PopupMatch2MagicLampsCollect from 'src/game/minigame/match2-timestep/magiclamps/PopupMatch2MagicLampsCollect';
import PopupMatch2MagicLampsRewards from 'src/game/minigame/match2-timestep/magiclamps/PopupMatch2MagicLampsRewards';
import PopupTeamIntro from 'src/game/minigame/match2-timestep/team/popups/PopupTeamIntro';
import PopupTeam from 'src/game/minigame/match2-timestep/team/popups/PopupTeam';
import PopupTeamLeave from 'src/game/minigame/match2-timestep/team/popups/PopupTeamLeave';
import PopupSwitchTeam from 'src/game/minigame/match2-timestep/team/popups/PopupSwitchTeam';
import PopupTeamInfo from 'src/game/minigame/match2-timestep/team/popups/PopupTeamInfo';
import PopupMarketingRewards from 'src/game/popups/PopupMarketingRewards';
import PopupMatch2Cheats from 'src/game/minigame/match2-timestep/components/PopupMatch2Cheats';
import PopupTeamChatEmotes from 'src/game/minigame/match2-timestep/team/popups/PopupTeamChatEmotes';
import PopupTeamChatMessages from 'src/game/minigame/match2-timestep/team/popups/PopupTeamChatMessages';
import PopupConfirmTeamVisit from 'src/game/minigame/match2-timestep/team/popups/PopupConfirmTeamVisit';
import PopupMatch2SocialContinue from 'src/game/minigame/match2-timestep/components/PopupMatch2SocialContinue';
import PopupTeamCompetitionLeaderboard from 'src/game/minigame/match2-timestep/team/popups/PopupTeamCompetitionLeaderboard';
import PopupTeamCompetitionIntro from 'src/game/minigame/match2-timestep/team/popups/PopupTeamCompetitionIntro';
import PopupTeamCompetitionInfo from 'src/game/minigame/match2-timestep/team/popups/PopupTeamCompetitionInfo';
import PopupMatch2MovePinch from 'src/game/minigame/match2-timestep/components/PopupMatch2MovePinch';
import PopupConfirmFriendRequest from 'src/game/friends/PopupConfirmFriendRequest';
import PopupResubscribePrompt from 'src/game/chatbot/PopupResubscribePrompt';
import PopupResubscribeForce from 'src/game/chatbot/PopupResubscribeForce';
import PopupResubscribeHintOverlay from 'src/game/chatbot/PopupResubscribeHintOverlay';
import PopupIncentivizedOAOverlay from 'src/game/chatbot/PopupIncentivizedOAOverlay';
import PopupIncentivizedOAReminder from 'src/game/chatbot/PopupIncentivizedOAReminder';
import PopupResubscribeReward from 'src/game/popups/PopupResubscribeReward';
import PopupTeamChestLeaderboard from 'src/game/minigame/match2-timestep/team/popups/PopupTeamChestLeaderboard';
import PopupTeamChestIntro from 'src/game/minigame/match2-timestep/team/popups/PopupTeamChestIntro';
import PopupStreakBattleRoyaleIntroV2 from 'src/game/streakbattleroyale/popups/PopupStreakBattleRoyaleIntroV2';
import PopupStreakBattleRoyaleMatchmakingV2 from 'src/game/streakbattleroyale/popups/PopupStreakBattleRoyaleMatchmakingV2';
import PopupMatch2AdContinue from 'src/game/minigame/match2-timestep/components/PopupMatch2AdContinue';
import PopupMatch2AdContinueStreak from 'src/game/minigame/match2-timestep/components/PopupMatch2AdContinueStreak';
import PopupAd from '../../ads/popups/PopupAd';
import PopupFullScreenError from './PopupFullScreenError';
import popupUpdateApp from 'src/game/native/popups/PopupUpdateApp';
import PopupUpdateAppSoft from 'src/game/native/popups/PopupUpdateAppSoft';
import PopupUpdateAppIncentivised from 'src/game/native/popups/PopupUpdateAppIncentivised';
import PopupUpdateAppIncentivisedReward from 'src/game/native/popups/PopupUpdateAppIncentivisedReward';
import PopupRevivalTall from 'src/game/visit/popups/PopupRevivalTall';
import PopupRevivalConfirm from 'src/game/visit/popups/PopupRevivalConfirm';
import PopupNoFriends from 'src/game/visit/popups/PopupNoFriends';
import { PopupGachaSelect } from 'src/game/gacha/popups/PopupGachaSelect';
import { PopupGacha } from 'src/game/gacha/popups/PopupGacha';
import PopupConfirmGacha from 'src/game/gacha/popups/PopupConfirmGacha';
import PopupGachaResults from 'src/game/gacha/popups/PopupGachaResults';
import PopupGachaIntro from 'src/game/gacha/popups/PopupGachaIntro';
import PopupInviteURL from 'src/game/popups/PopupInviteURL';
import PopupInviteURLCopied from 'src/game/popups/PopupInviteURLCopied';
import PopupFriendJoinedReward from 'src/game/popups/PopupFriendJoinedReward';
import PopupVisitReferral from 'src/game/popups/PopupVisitReferral';
import PopupCardsInfo from 'src/game/cards/popups/PopupCardsInfo';
import PopupCardCollections from 'src/game/cards/popups/PopupCardCollections';
import PopupCards from 'src/game/cards/popups/PopupCards';
import PopupCardsPackReward from 'src/game/cards/popups/PopupCardsPackReward';
import PopupCardDetails from 'src/game/cards/popups/PopupCardDetails';
import PopupCardResponse from 'src/game/cards/popups/PopupCardResponse';
import PopupCardsReceived from 'src/game/cards/popups/PopupCardsReceived';
import PopupCardSendList from 'src/game/cards/popups/PopupCardSendList';
import PopupCardPicker from 'src/game/cards/popups/PopupCardPicker';
import PopupCardTradeProposeList from 'src/game/cards/popups/PopupCardTradeProposeList';
import PopupCardRequestProposeList from 'src/game/cards/popups/PopupCardRequestProposeList';
import PopupCardTrades from 'src/game/cards/popups/PopupCardTrades';
import PopupCardTradeShareInvite from 'src/game/cards/popups/PopupCardTradeShareInvite';
import PopupCardTradeSent from 'src/game/cards/popups/PopupCardTradeSent';
import PopupCardsAlbumReward from 'src/game/cards/popups/PopupCardsAlbumReward';
import PopupOpenCrate from 'src/game/puzzlecoins/popups/PopupOpenCrate';
import PopupLineDemoLogin from 'src/game/demo/PopupLineDemoLogin';
import PopupGachaInfo from 'src/game/gacha/popups/PopupGachaInfo';
import PopupPetStarterPack from 'src/game/starterpack/popups/PopupPetStarterPack';
import PopupMatch2MovePinchRetry from 'src/game/minigame/match2-timestep/components/PopupMatch2MovePinchRetry';
import PopupSuperLollipopInfo from 'src/game/superLollipop/popups/PopupSuperLollipopInfo';
import PopupSuperLollipopProgress from 'src/game/superLollipop/popups/PopupSuperLollipopProgress';
import PopupSuperLollipopActive from 'src/game/superLollipop/popups/PopupSuperLollipopActive';
import PopupSuperLollipopLost from 'src/game/superLollipop/popups/PopupSuperLollipopLost';
import PopupSuperLollipopPinchRetry from 'src/game/superLollipop/popups/PopupSuperLollipopPinchRetry';
import PopupWeeklyLeaderboardInfo from 'src/game/weeklyLeaderboard/popups/PopupWeeklyLeaderboardInfo';
import PopupNativeLineGuestLoginNew from 'src/game/guest/popups/PopupNativeLineGuestLoginNew';
import PopupWeeklyLeaderboard from 'src/game/weeklyLeaderboard/popups/PopupWeeklyLeaderboard';
import PopupGuestWeeklyLeaderboard from 'src/game/weeklyLeaderboard/popups/PopupGuestWeeklyLeaderboard';
import PopupChestRewards from './PopupChestRewards';
import PopupTreasureExpress from 'src/game/treasureExpress/popups/PopupTreasureExpress';
import PopupTreasureExpressInfo from 'src/game/treasureExpress/popups/PopupTreasureExpressInfo';
import PopupChampionsLeagueInfo from 'src/game/championsLeague/popups/PopupChampionsLeagueInfo';
import PopupChampionsLeagueLeaderboard from 'src/game/championsLeague/popups/PopupChampionsLeagueLeaderboard';
import PopupChampionsLeagueClaim from 'src/game/championsLeague/popups/PopupChampionsLeagueClaim';
import PopupSelectSave from 'src/game/guest/popups/PopupSelectSave';
import PopupSettingsPurchaseInfo from './PopupSettingsPurchaseInfo';
import PopupStreakBattleRoyaleRetryV2 from 'src/game/streakbattleroyale/popups/PopupStreakBattleRoyaleRetryV2';
import PopupStreakBattleRoyaleRewardV2 from 'src/game/streakbattleroyale/popups/PopupStreakBattleRoyaleRewardV2';
import PopupStreakBattleRoyaleV2 from 'src/game/streakbattleroyale/popups/PopupStreakBattleRoyaleV2';
import PopupGenericInviteFriends from 'src/game/popups/PopupGenericInviteFriends';
import PopupRevivalSimple from 'src/game/visit/popups/PopupRevivalSimple';
import PopupRevivalConfirmSimple from 'src/game/visit/popups/PopupRevivalConfirmSimple';
import PopupProfileV2 from 'src/game/popups/PopupProfileV2';
import PopupEditProfileV2 from 'src/game/popups/PopupEditProfileV2';
import PopupFriends from 'src/game/friends/popups/PopupFriends';
import PopupFriendsConfirmation from 'src/game/friends/popups/PopupFriendsConfirmation';
import PopupFriendsTutorial from 'src/game/friends/popups/PopupFriendsTutorial';
import PopupFriendRequestConfirm from 'src/game/friends/popups/PopupFriendRequestConfirm';
import PopupAddFriend from 'src/game/friends/popups/PopupAddFriend';
import PopupAddFriendQRFullscreen from 'src/game/friends/popups/PopupAddFriendQRFullscreen';
import PopupFriendRequests from 'src/game/friends/popups/PopupFriendRequests';
import PopupFriendsList from 'src/game/friends/popups/PopupFriendsList';
import PopupUserProfile from 'src/game/friends/popups/PopupUserProfile';
import PopupFriendRemoveConfirm from 'src/game/friends/popups/PopupFriendRemoveConfirm';
import { PopupDialogOrigin } from 'src/lib/popups/popupOpenClose';
import PopupMatch2MovePinchAchievements from 'src/game/minigame/match2-timestep/movesPinch/popups/PopupMatch2MovePinchAchievements';
import PopupMatch2MovePinchStreaks from 'src/game/minigame/match2-timestep/movesPinch/popups/PopupMatch2MovePinchStreaks';
import PopupSelectSaveConfirmation from 'src/game/guest/popups/PopupSelectSaveConfirmation';
import PopupLineGuestLoginReward from 'src/game/guest/popups/PopupLineGuestLoginReward';
import PopupHomeShortcut from 'src/game/homeShortcut/popups/PopupHomeShortcut';
import PopupHomeShortcutReward from 'src/game/homeShortcut/popups/PopupHomeShortcutReward';
import PopupUnfriendConfirmation from 'src/game/friends/popups/PopupUnfriendConfirmation';
import PopupRescueLevelPlay from 'src/game/rescueLevel/popups/PopupRescueLevelPlay';
import PopupRescueLevelWin from 'src/game/rescueLevel/popups/PopupRescueLevelWin';
import PopupMiniAppPurchaseToSNudge from 'src/game/popups/PopupMiniAppPurchaseToSNudge';
import PopupBuddiesBaking from 'src/game/buddies/popups/PopupBuddiesBaking';
import PopupBuddiesInfo from 'src/game/buddies/popups/PopupBuddiesInfo';
import PopupBuddiesInvite from 'src/game/buddies/popups/PopupBuddiesInvite';
import PopupBuddiesReward from 'src/game/buddies/popups/PopupBuddiesReward';
import PopupBuddiesIncomingInvite from 'src/game/buddies/popups/PopupBuddiesIncomingInvite';
import PopupBuddiesJoinRewards from 'src/game/buddies/popups/PopupBuddiesJoinRewards';
import PopupJanken from 'src/game/janken/popups/PopupJanken';
import PopupJankenInfo from 'src/game/janken/popups/PopupJankenInfo';
import PopupJankenReward from 'src/game/janken/popups/PopupJankenReward';
import PopupDreamDriftIntro from 'src/game/dreamDrift/popups/PopupDreamDriftIntro';
import PopupDreamDriftInfo from 'src/game/dreamDrift/popups/PopupDreamDriftInfo';
import PopupDreamDriftHeroSelection from 'src/game/dreamDrift/popups/PopupDreamDriftHeroSelection';
import PopupDreamDriftPregame from 'src/game/dreamDrift/popups/PopupDreamDriftPregame';
import PopupDreamDriftMap from 'src/game/dreamDrift/popups/PopupDreamDriftMap';
import PopupDreamDriftLost from 'src/game/dreamDrift/popups/PopupDreamDriftLost';
import PopupDreamDriftComplete from 'src/game/dreamDrift/popups/PopupDreamDriftComplete';
import PopupDreamDriftContinue from 'src/game/dreamDrift/popups/PopupDreamDriftContinue';

export const popupRegistry = {
  // Term / Privacy popups
  popupTermsPolicyDetails: popupBoilerplate(PopupTermsPolicyDetails),
  popupToSUpdated: popupBoilerplate(PopupToSUpdated),

  // Conversation
  popupConversationScript: popupBoilerplate(PopupConversationScript, 'pet'),
  popupSelectionalScript: popupBoilerplate(PopupSelectionalScript, 'pet'),
  popupDescriptiveScript: popupBoilerplate(PopupDescriptiveScript, 'pet'),
  popupSpeechBubble: popupBoilerplate(PopupSpeechBubble, 'pet'),
  popupWantToAddFriend: popupBoilerplate(PopupWantToAddFriend, 'pet'),
  popupPetNameInput: popupBoilerplate(PopupPetNameInput),

  // Care popups
  popupSelectCareItem: popupBoilerplate(PopupSelectCareItem),
  popupConfirmCareItem: popupBoilerplate(PopupConfirmCareItem),

  // Daycare popups
  popupConfirmDaycare: popupBoilerplate(PopupConfirmDaycare),
  popupExitDaycare: popupBoilerplate(PopupExitDaycare),

  // Social popups
  popupInviteFriends: popupBoilerplate(PopupInviteFriends),
  popupConfirmInvite: popupBoilerplate(PopupConfirmInvite),
  popupConfirmInviteMulti: popupBoilerplate(PopupConfirmInviteMulti),
  popupInviteReward: popupBoilerplate(PopupInviteReward),
  popupInviteChallenge: popupBoilerplate(PopupInviteChallenge),
  popupInviteChallengeComplete: popupBoilerplate(PopupInviteChallengeComplete),
  popupInviteURL: popupBoilerplate(PopupInviteURL),
  popupInviteURLCopied: popupBoilerplate(PopupInviteURLCopied),
  popupFriendJoinedReward: popupBoilerplate(PopupFriendJoinedReward),
  popupVisitReferral: popupBoilerplate(PopupVisitReferral),
  popupGenericInviteFriends: popupBoilerplate(PopupGenericInviteFriends),

  // Tutorial popups
  popupAcceptToS: popupBoilerplate(PopupAcceptToS),
  popupTutorialStep: popupBoilerplate(PopupTutorialStep),
  popupTutorialReward: popupBoilerplate(PopupTutorialReward),

  // Settings popups
  popupSettings: popupBoilerplate(PopupSettings),
  popupFaq: popupBoilerplate(PopupFaq),
  popupSettingsPurchaseInfo: popupBoilerplate(PopupSettingsPurchaseInfo),

  // Error popups
  popupError: popupBoilerplate(PopupError),
  popupFullScreenError: popupBoilerplate(PopupFullScreenError),
  popupNetworkError: popupBoilerplate(PopupNetworkError),
  popupReplicationError: popupBoilerplate(PopupReplicationError),
  popupSessionDesyncError: popupBoilerplate(PopupSessionDesyncError),
  popupVersionError: popupBoilerplate(PopupVersionError),

  // Generic popups
  popupInfo: popupBoilerplate(PopupInfo),
  popupConfirmation: popupBoilerplate(PopupConfirmation),
  popupNotification: popupBoilerplate(PopupNotification),
  popupFeatureDisabled: popupBoilerplate(PopupFeatureDisabled),
  popupModalWhite: popupBoilerplate(PopupModalWhite),
  popupShadowBox: popupBoilerplate(PopupShadowBox),
  popupConfirmationWhite: popupBoilerplate(PopupConfirmationWhite),

  // Shop
  popupCoinsShop: popupBoilerplate(PopupCoinsShop),
  popupCoinsExchanged: popupBoilerplate(PopupCoinsExchanged),
  popupEnergyShop: popupBoilerplate(PopupEnergyShop),
  popupEnergyExchanged: popupBoilerplate(PopupEnergyExchanged),
  popupNewPurchaseComplete: popupBoilerplate(PopupNewPurchaseComplete),
  popupPurchaseCanceled: popupBoilerplate(PopupPurchaseCanceled),
  popupPurchaseFailed: popupBoilerplate(PopupPurchaseFailed),
  popupPurchaseFatal: popupBoilerplate(PopupPurchaseFatal),

  // Admin reimburse message
  popupAdminReimburse: popupBoilerplate(PopupAdminReimburse),
  popupAdminRename: popupBoilerplate(PopupAdminRename),

  // Profile
  popupProfile: popupBoilerplate(PopupProfile),
  popupProfileV2: popupBoilerplate(PopupProfileV2),
  popupEditProfile: popupBoilerplate(PopupEditProfile),
  popupEditProfileV2: popupBoilerplate(PopupEditProfileV2),
  popupAvatarSelection: popupBoilerplate(PopupAvatarSelection),

  // Match 2
  popupMatch2Chest: popupBoilerplate(PopupMatch2Chest),
  popupMatch2DailyBonus: popupBoilerplate(PopupMatch2DailyBonus),
  popupDailyBonusTosNudge: popupBoilerplate(PopupDailyBonusTosNudge),
  popupTosPuzzlePinchNudge: popupBoilerplate(PopupTosPuzzlePinchNudge),
  popupMatch2Pregame: popupBoilerplate(PopupMatch2Pregame),
  popupMatch2LevelComplete: popupBoilerplate(PopupMatch2LevelComplete),
  popupMatch2GrantRewards: popupBoilerplate(PopupMatch2GrantRewards),
  popupMatch2LevelFailed: popupBoilerplate(PopupMatch2LevelFailed),
  popupMatch2Pinch: popupBoilerplate(PopupMatch2Pinch),
  popupMatch2PinchRetry: popupBoilerplate(PopupMatch2Pinch), // Duplicated for analytical purposes
  popupMatch2PinchTournamentStreak: popupBoilerplate(
    PopupMatch2PinchTournamentStreak,
  ),
  popupStarsPinch: popupBoilerplate(PopupStarsPinch),
  popupConfirmMatch2Booster: popupBoilerplate(PopupConfirmMatch2Booster),
  popupConfirmMatch2Powerup: popupBoilerplate(PopupConfirmMatch2Powerup),
  popupMatch2FrenzyIntro: popupBoilerplate(PopupMatch2FrenzyIntro),
  popupMatch2PlayOnApp: popupBoilerplate(PopupMatch2PlayOnApp),
  popupMatch2Tournament: popupBoilerplate(PopupMatch2Tournament),
  popupMatch2TournamentStreak: popupBoilerplate(PopupMatch2TournamentStreak),
  popupMatch2TournamentInfo: popupBoilerplate(PopupMatch2TournamentInfo),
  popupMatch2DailyChallenge: popupBoilerplate(PopupMatch2DailyChallenge),
  popupMatch2RacesIntro: popupBoilerplate(PopupMatch2RacesIntro),
  popupMatch2TimedRacesLeaderboard: popupBoilerplate(
    PopupMatch2TimedRacesLeaderboard,
  ),
  popupMatch2TargetRacesLeaderboard: popupBoilerplate(
    PopupMatch2TargetRacesLeaderboard,
  ),
  popupMatch2ShopBundles: popupBoilerplate(PopupMatch2ShopBundles),
  popupMatch2Quit: popupBoilerplate(PopupMatch2Quit),
  popupMatch2BundleSale: popupBoilerplate(PopupMatch2BundleSale),
  popupMatch2FreeContinue: popupBoilerplate(PopupMatch2FreeContinue),

  // Continue Popup Visual AB Test
  popupMatch2MovePinch: popupBoilerplate(PopupMatch2MovePinch),
  popupMatch2MovePinchRetry: popupBoilerplate(PopupMatch2MovePinchRetry),
  popupMatch2MovePinchAchievements: popupBoilerplate(
    PopupMatch2MovePinchAchievements,
  ),
  popupMatch2MovePinchStreaks: popupBoilerplate(PopupMatch2MovePinchStreaks),

  // Magic Lamps
  popupMatch2MagicLamps: popupBoilerplate(PopupMatch2MagicLamps),
  popupMatch2MagicLampsCollect: popupBoilerplate(PopupMatch2MagicLampsCollect),
  popupMatch2MagicLampsRewards: popupBoilerplate(PopupMatch2MagicLampsRewards),

  // Masters League
  popupLeaguesInfoPuzzleCoins: popupBoilerplate(PopupLeaguesInfoPuzzleCoins),

  // Champion's League
  popupChampionsLeagueInfo: popupBoilerplate(PopupChampionsLeagueInfo),
  popupChampionsLeagueLeaderboard: popupBoilerplate(
    PopupChampionsLeagueLeaderboard,
  ),
  popupChampionsLeagueClaim: popupBoilerplate(PopupChampionsLeagueClaim),

  // Team
  popupTeamIntro: popupBoilerplate(PopupTeamIntro),
  popupTeam: popupBoilerplate(PopupTeam),
  popupTeamLeave: popupBoilerplate(PopupTeamLeave),
  popupSwitchTeam: popupBoilerplate(PopupSwitchTeam),
  popupTeamInfo: popupBoilerplate(PopupTeamInfo),
  popupTeamChatEmotes: popupBoilerplate(PopupTeamChatEmotes),
  popupTeamChatMessages: popupBoilerplate(PopupTeamChatMessages),
  popupConfirmTeamVisit: popupBoilerplate(PopupConfirmTeamVisit),
  popupTeamCompetitionLeaderboard: popupBoilerplate(
    PopupTeamCompetitionLeaderboard,
  ),
  popupTeamCompetitionIntro: popupBoilerplate(PopupTeamCompetitionIntro),
  popupTeamCompetitionInfo: popupBoilerplate(PopupTeamCompetitionInfo),
  popupTeamChestLeaderboard: popupBoilerplate(PopupTeamChestLeaderboard),
  popupTeamChestIntro: popupBoilerplate(PopupTeamChestIntro),

  // Match2 Continue
  popupSocialContinue: popupBoilerplate(PopupMatch2SocialContinue),
  popupAdContinue: popupBoilerplate(PopupMatch2AdContinue),
  popupAdContinueStreak: popupBoilerplate(PopupMatch2AdContinueStreak),

  // Streak Event
  popupStreakBattleRoyaleIntroV2: popupBoilerplate(
    PopupStreakBattleRoyaleIntroV2,
  ),
  popupStreakBattleRoyaleV2: popupBoilerplate(PopupStreakBattleRoyaleV2),
  popupStreakBattleRoyaleMatchmakingV2: popupBoilerplate(
    PopupStreakBattleRoyaleMatchmakingV2,
  ),
  popupStreakBattleRoyaleRewardV2: popupBoilerplate(
    PopupStreakBattleRoyaleRewardV2,
  ),
  popupStreakBattleRoyaleRetryV2: popupBoilerplate(
    PopupStreakBattleRoyaleRetryV2,
  ),

  // Gifts
  popupGiftsList: popupBoilerplate(PopupGiftsList),
  popupGiftsConfirmation: popupBoilerplate(PopupGiftsConfirmation),
  popupGiftsConfirmationMulti: popupBoilerplate(PopupGiftsConfirmationMulti),

  // Level
  popupLevelUPReward: popupBoilerplate(PopupLevelUPReward),

  // Visit
  popupVisitReward: popupBoilerplate(PopupVisitReward),
  popupVisitFriend: popupBoilerplate(PopupVisitFriend),
  popupConfirmVisitFriend: popupBoilerplate(PopupConfirmVisitFriend),
  popupRevivalTall: popupBoilerplate(PopupRevivalTall),
  popupRevivalConfirm: popupBoilerplate(PopupRevivalConfirm),
  popupRevivalSimple: popupBoilerplate(PopupRevivalSimple),
  popupRevivalConfirmSimple: popupBoilerplate(PopupRevivalConfirmSimple),
  popupNoFriends: popupBoilerplate(PopupNoFriends),

  // Encyclopedia
  popupEncyclopedia: popupBoilerplate(PopupEncyclopedia),
  popupEncyclopediaTutorial: popupBoilerplate(PopupEncyclopediaTutorial),
  popupEncyclopediaDetails: popupBoilerplate(PopupEncyclopediaDetails),

  // Native
  popupLoginCrossplay: popupBoilerplate(PopupLoginCrossplay),
  popupNativeLineGuestLogin: popupBoilerplate(PopupNativeLineGuestLogin),
  popupNativeLineGuestLoginNew: popupBoilerplate(PopupNativeLineGuestLoginNew),
  popupSelectSave: popupBoilerplate(PopupSelectSave),
  popupSelectSaveConfirmation: popupBoilerplate(PopupSelectSaveConfirmation),
  popupInstallNativeReward: popupBoilerplate(PopupInstallNativeReward),
  popupUpdateApp: popupBoilerplate(popupUpdateApp),
  popupUpdateAppSoft: popupBoilerplate(PopupUpdateAppSoft),
  popupUpdateAppIncentivised: popupBoilerplate(PopupUpdateAppIncentivised),
  popupUpdateAppIncentivisedReward: popupBoilerplate(
    PopupUpdateAppIncentivisedReward,
  ),
  popupLineGuestLoginReward: popupBoilerplate(PopupLineGuestLoginReward),

  // Duo
  popupDuoResponse: popupBoilerplate(PopupDuoResponse),
  popupDuoResponseSuccess: popupBoilerplate(PopupDuoResponseSuccess),
  popupDuoInvitations: popupBoilerplate(PopupDuoInvitations),
  popupDuoReminderConfirmation: popupBoilerplate(PopupDuoReminderConfirmation),
  popupDuoReminderSuccess: popupBoilerplate(PopupDuoReminderSuccess),
  popupDuoReward: popupBoilerplate(PopupDuoReward),

  // Family
  popupGrowthRecord: popupBoilerplate(PopupGrowthRecord),
  popupFamilyTree: popupBoilerplate(PopupFamilyTree),

  // Decoration
  popupDecorationPurchaseConfirmation: popupBoilerplate(
    PopupDecorationPurchaseConfirmation,
  ),
  popupSelectDecorationRoom: popupBoilerplate(PopupSelectDecorationRoom),

  // Gacha
  popupGacha: popupBoilerplate(PopupGacha),
  popupGachaSelect: popupBoilerplate(PopupGachaSelect),
  popupConfirmGacha: popupBoilerplate(PopupConfirmGacha),
  popupGachaResults: popupBoilerplate(PopupGachaResults),
  popupGachaIntro: popupBoilerplate(PopupGachaIntro),
  popupGachaInfo: popupBoilerplate(PopupGachaInfo),

  // Catalog
  popupCatalogItemSell: popupBoilerplate(PopupCatalogItemSell),
  popupCatalogList: popupBoilerplate(PopupCatalogList),

  // Redo evolution
  popupRedoEvolution: popupBoilerplate(PopupRedoEvolution),
  popupRedoEvolutionChoice: popupBoilerplate(PopupRedoEvolutionChoice),

  // Push notifications
  popupPNPermissionReminder: popupBoilerplate(PopupPNPermissionReminder),
  popupPNPermission: popupBoilerplate(PopupPNPermission),

  // Growth capsule
  popupConfirmGrowthCapsule: popupBoilerplate(PopupConfirmGrowthCapsule),

  // Komoju hosted fields payment popup
  popupOpenWebPay: popupBoilerplate(PopupOpenWebPay),

  // Marketing
  popupMarketingRewards: popupBoilerplate(PopupMarketingRewards),

  // BuruBuru friends
  popupConfirmFriendRequest: popupBoilerplate(PopupConfirmFriendRequest),

  // Resubscribtion
  popupResubscribePrompt: popupBoilerplate(PopupResubscribePrompt),
  popupResubscribeForce: popupBoilerplate(PopupResubscribeForce),
  popupResubscribeHintOverlay: popupBoilerplate(PopupResubscribeHintOverlay),
  popupIncentivizedOAOverlay: popupBoilerplate(PopupIncentivizedOAOverlay),
  popupIncentivizedOAReminder: popupBoilerplate(PopupIncentivizedOAReminder),
  popupResubscribeReward: popupBoilerplate(PopupResubscribeReward),

  // Stickers
  popupStickers: popupBoilerplate(PopupStickers),

  // Cards
  popupCardsInfo: popupBoilerplate(PopupCardsInfo),
  popupCardCollections: popupBoilerplate(PopupCardCollections),
  popupCards: popupBoilerplate(PopupCards),
  popupCardsPackReward: popupBoilerplate(PopupCardsPackReward),
  popupCardDetails: popupBoilerplate(PopupCardDetails),
  popupCardResponse: popupBoilerplate(PopupCardResponse),
  popupCardsReceived: popupBoilerplate(PopupCardsReceived),
  popupCardSendList: popupBoilerplate(PopupCardSendList),
  popupCardPicker: popupBoilerplate(PopupCardPicker),
  popupCardTradeProposeList: popupBoilerplate(PopupCardTradeProposeList),
  popupCardRequestProposeList: popupBoilerplate(PopupCardRequestProposeList),
  popupCardTrades: popupBoilerplate(PopupCardTrades),
  popupCardTradeShareInvite: popupBoilerplate(PopupCardTradeShareInvite),
  popupCardTradeSent: popupBoilerplate(PopupCardTradeSent),
  popupCardsAlbumReward: popupBoilerplate(PopupCardsAlbumReward),

  // BPoints From Puzzle
  popupOpenCrate: popupBoilerplate(PopupOpenCrate),

  // OpenWeb line login
  popupLineDemoLogin: popupBoilerplate(PopupLineDemoLogin),

  // Pet starter pack popup
  popupPetStarterPack: popupBoilerplate(PopupPetStarterPack),

  // Super Lollipop popups
  popupSuperLollipopInfo: popupBoilerplate(PopupSuperLollipopInfo),
  popupSuperLollipopProgress: popupBoilerplate(PopupSuperLollipopProgress),
  popupSuperLollipopActive: popupBoilerplate(PopupSuperLollipopActive),
  popupSuperLollipopLost: popupBoilerplate(PopupSuperLollipopLost),
  popupSuperLollipopPinchRetry: popupBoilerplate(PopupSuperLollipopPinchRetry),

  // Weekly Leaderboard popups
  popupWeeklyLeaderboardInfo: popupBoilerplate(PopupWeeklyLeaderboardInfo),
  popupWeeklyLeaderboard: popupBoilerplate(PopupWeeklyLeaderboard),
  popupGuestWeeklyLeaderboard: popupBoilerplate(PopupGuestWeeklyLeaderboard),
  popupChestRewards: popupBoilerplate(PopupChestRewards),

  // Treasure express
  popupTreasureExpress: popupBoilerplate(PopupTreasureExpress),
  popupTreasureExpressInfo: popupBoilerplate(PopupTreasureExpressInfo),

  // Dream Drift
  popupDreamDriftIntro: popupBoilerplate(PopupDreamDriftIntro),
  popupDreamDriftInfo: popupBoilerplate(PopupDreamDriftInfo),
  popupDreamDriftHeroSelection: popupBoilerplate(PopupDreamDriftHeroSelection),
  popupDreamDriftPregame: popupBoilerplate(PopupDreamDriftPregame),
  popupDreamDriftMap: popupBoilerplate(PopupDreamDriftMap),
  popupDreamDriftLost: popupBoilerplate(PopupDreamDriftLost),
  popupDreamDriftComplete: popupBoilerplate(PopupDreamDriftComplete),
  popupDreamDriftContinue: popupBoilerplate(PopupDreamDriftContinue),

  // Baking Buddies
  popupBuddiesBaking: popupBoilerplate(PopupBuddiesBaking),
  popupBuddiesInfo: popupBoilerplate(PopupBuddiesInfo),
  popupBuddiesInvite: popupBoilerplate(PopupBuddiesInvite),
  popupBuddiesReward: popupBoilerplate(PopupBuddiesReward),
  popupBuddiesIncomingInvite: popupBoilerplate(PopupBuddiesIncomingInvite),
  popupBuddiesJoinRewards: popupBoilerplate(PopupBuddiesJoinRewards),

  // Friends
  popupFriends: popupBoilerplate(PopupFriends),
  popupFriendsConfirmation: popupBoilerplate(PopupFriendsConfirmation),
  popupFriendsTutorial: popupBoilerplate(PopupFriendsTutorial),
  popupFriendRequestConfirm: popupBoilerplate(PopupFriendRequestConfirm),
  popupAddFriend: popupBoilerplate(PopupAddFriend),
  popupAddFriendQRFullscreen: popupBoilerplate(PopupAddFriendQRFullscreen),
  popupFriendRequests: popupBoilerplate(PopupFriendRequests),
  popupFriendsList: popupBoilerplate(PopupFriendsList),
  popupUserProfile: popupBoilerplate(PopupUserProfile),
  popupFriendRemoveConfirm: popupBoilerplate(PopupFriendRemoveConfirm),

  popupUnfriendConfirmation: popupBoilerplate(PopupUnfriendConfirmation),

  // Home Shortcut
  popupHomeShortcut: popupBoilerplate(PopupHomeShortcut),
  popupHomeShortcutReward: popupBoilerplate(PopupHomeShortcutReward),

  // Rescue Level
  popupRescueLevelPlay: popupBoilerplate(PopupRescueLevelPlay),
  popupRescueLevelWin: popupBoilerplate(PopupRescueLevelWin),

  // Janken
  popupJanken: popupBoilerplate(PopupJanken),
  popupJankenInfo: popupBoilerplate(PopupJankenInfo),
  popupJankenReward: popupBoilerplate(PopupJankenReward),

  // Miniapp
  popupMiniAppPurchaseToSNudge: popupBoilerplate(PopupMiniAppPurchaseToSNudge),

  // Cheat popups
  ...(process.env.IS_DEVELOPMENT
    ? {
        popupCheats: null as unknown as Popup, // Fill in popup manager.
        popupTestPopups: null as unknown as Popup, // Fill in popup manager.
        popupCheatsAB: popupBoilerplate(PopupCheatsAB), // Fill in popup manager.
        popupAd: popupBoilerplate(PopupAd),
        popupMatch2Cheats: popupBoilerplate(PopupMatch2Cheats),
      }
    : null),
};

//
// Types.

type PopupRegistry = typeof popupRegistry;
export type PopupID = keyof PopupRegistry;

type PopupArgs<P> = Parameters<Extract<P, (...args: any) => any>>[0];
type PopupOnClose<P> = Parameters<
  ReturnType<Extract<P, (...args: any) => any>>['onClose']
>;

export type PopupOpenArgs<TPopupID extends PopupID> = PopupArgs<
  PopupRegistry[TPopupID]
>['openArgs'] & {
  origin?: PopupDialogOrigin;
  additionalTracking?: Record<string, any>;
};
export type PopupCloseArgs<TPopupID extends PopupID> = PopupOnClose<
  PopupRegistry[TPopupID]
>;

//
// Helpers.

export function isPopupId(id: string): id is PopupID {
  return id in popupRegistry;
}
